// MainLayoutNonAdmin.tsx

import React from 'react';
import { AdvisorAccessProvider } from '../../context/AdvisorAccessContext';
import AdvisorModeBar from '../Advisor/AdvisorModeBar';
import MainLayoutBase from '../MainLayoutBase';

interface Props {
  children: React.ReactNode;
  minimal?: boolean; // not used but here for consistency
}

export default function MainLayoutNonAdmin({ children, minimal = false }: Props) {
  return (
    <AdvisorAccessProvider>
      <MainLayoutBase appendSection={() => <AdvisorModeBar />} minimal={minimal} showVeraChat>
        {children}
      </MainLayoutBase>
    </AdvisorAccessProvider>
  );
}
